export enum DeviceStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
}
